export enum EventType {
    'REFRESH.MENU.USER_DATA' = 'REFRESH.MENU.USER_DATA',
    'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA' = 'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA',
    'REPORT.DEFECTS.RELOAD' = 'REPORT.DEFECTS.RELOAD',
    'REPORT.LIST.RELOAD' = 'REPORT.LIST.RELOAD',
    'REPORT.NETWORK_STATUS_CHANGE' = 'REPORT.NETWORK_STATUS_CHANGE',
    'REFRESH.BACK_RIDE_FORM_FIELDS' = 'REFRESH.BACK_RIDE_FORM_FIELDS',
    'REPORT.AUTO_SAVE' = 'REPORT.AUTO_SAVE',
}